import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GuardMovePage } from "@/features/quality/components/guard/guard-move-page";

/** GS SLOC Update: move many stored guard samples at once (user, 2026-10-16). */
export const Route = createFileRoute("/_app/quality/guard-samples/move")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.guard_samples"))
      throw redirect({ to: "/" });
  },
  component: GuardMovePage,
});
